<div class="dialog-header">
  <app-bar
    title="Pagar conta"
    [backButtonProps]="{ icon: 'caret-down', variant: 'regular', color: 'neutral', size: 'medium' }"
    (backButtonClick)="handleClose()"
  ></app-bar>
</div>
<div class="dialog-container">
  <div class="dialog-body">
    <div class="d-flex align-center space-between mb-3">
      <h3 class="title-large">Como quer pagar?</h3>
      <mnt-badge
        [label]="'Total: ' + (total | currency)"
        size="tiny"
        color="primary"
      ></mnt-badge>
    </div>

    <div class="d-column gap-2">
      <mnt-button
        variant="regular"
        color="neutral"
        size="large"
        full-width
        label="Valor total"
        (buttonClick)="handlePayment('TOTAL')"
        class="w-100"
      ></mnt-button>
      <mnt-button
        variant="regular"
        color="neutral"
        size="large"
        full-width
        label="Só o que consumi"
        (buttonClick)="handlePayment('PARTIAL')"
        class="w-100"
        *ngIf="canPayPartial"
      ></mnt-button>
      <mnt-button
        variant="regular"
        color="neutral"
        size="large"
        full-width
        label="Valor personalizado"
        (buttonClick)="handlePayment('CUSTOM')"
        class="w-100"
      ></mnt-button>
    </div>
  </div>
</div>